import Button from '@talkdesk/cobalt-react-button'

const ActionButton = ({ isProcessing, children, isDisabled, ...props }) => (
  <Button {...props} disabled={isDisabled || isProcessing}>
    {children}
  </Button>
)

export default ActionButton
